module.exports = __webpack_public_path__ + "img/聚焦时尚p2.1ac7f6ae.png";